export default __webpack_public_path__ + "static/media/ex-login.5def7427.jpg";